import React from 'react';
import classname from 'classnames';
import { Popper } from 'zarm';
import { Icon } from '@iyunbao/components';
import CardList from '../cardList';
import Button from '../form/button';

import { ActionProps, BaseWidgetProps } from '../utils/type';

export interface ICardContainer extends BaseWidgetProps {
  title?: string;
  extra: any;
  childrens: any[];
  action?: ActionProps;
  log?: string;
  titleIconStyle?: any;
}

/**
 * 容器组件
 * @param props
 */
function CardContainer(props: ICardContainer) {
  const {
    prefixCls = 'crm-card-container',
    className,
    childrens,
    style = {},
    _crengine,
    title,
    extra,
    titleIconStyle = '',
    action: propsAction,
    ...rest
  } = props;

  const cls = classname({
    [`${prefixCls}`]: true,
    className: true,
  });

  /**
   * 展示卡片右侧的额外信息，包含按钮类型和气泡卡片类型
   * @returns
   */
  const renderExtra = () => {
    if (extra) {
      if (extra.widget === 'button') {
        return (
          <div className="crm-card-container-item-content-description">
            <Button className="crm-card-container-item-content__button" {...extra.wprops} _crengine={_crengine} />
          </div>
        );
      }
      if (extra.widget === 'popper') {
        return (
          <Popper content={extra.wprops.description} destroy trigger="click" className="crm-card-container-item-content-popper">
            <div className="crm-card-container-item-content-extra" style={extra.wprops.style}>
              <Icon type="wenhao" />
              <span className="crm-card-container-item-content-extra__text">{extra.wprops.label}</span>
            </div>
          </Popper>
        );
      }
    }
    return null;
  };

  /**
   * 渲染大标题
   * @returns
   */
  const renderTitle = () => {
    if (title || extra) {
      const titleCls = classname({
        'crm-card-container-item-content-label': true,
        'crm-card-container-item-content-title': !!title,
      });
      return (
        <div className="crm-card-container-item-content">
          {titleIconStyle && <span style={titleIconStyle} />}
          {title && <div className={titleCls}>{title}</div>}
          {renderExtra()}
        </div>
      );
    }
    return null;
  };

  return (
    <div className={cls} style={style} {...rest}>
      {renderTitle()}
      {(childrens || []).map((item) => {
        if (item.widget === 'card-list') {
          return <CardList {...item.wprops} _crengine={_crengine} key={item.wprops.title} />;
        }
        return null;
      })}
    </div>
  );
}

export default CardContainer;
